import * as React from "react"
import {
  Text,
  HStack,
  Image,
} from "@chakra-ui/react"
import { brandConfig } from "./brandConfig"

// Main Logo component
export const Logo = React.forwardRef<HTMLDivElement, any>((props, ref) => {
  return (
    <HStack spacing={3} align="center" ref={ref} {...props}>
      <Image 
        src="/assets/onepropertyaustralia/logo.png"
        alt="One Property Australia Logo"
        height={{ base: "32px", md: "40px" }}
        width="auto"
        objectFit="contain"
      />
      <Text 
        fontSize={{ base: "lg", md: "xl" }}
        fontWeight="600" 
        color="white"
        letterSpacing="-0.02em"
        whiteSpace="nowrap"
        fontFamily="'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif"
      >
        {brandConfig.siteName}
      </Text>
    </HStack>
  )
})

Logo.displayName = 'Logo'

export default Logo;